import { decodeHexResponse } from '../_common/common.utils';
import SectionWiseFetchDetailsTypes from './SectionWiseFetchDetails.types';

const INITIAL_STATE = {
	sectionWiseFetchResponse: null,
	hoSectionWiseFetchResponse: null,
	dateWiseSectionAttendanceFetchResponse: null,
};

const sectionWiseFetchDetailsReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		// case SectionWiseFetchDetailsTypes.SECTION_WISE_FETCH_START:
		// 	return { ...state, sectionWiseFetchResponse: null };
		case SectionWiseFetchDetailsTypes.SECTION_WISE_FETCH_SUCCESS:
			return {
				...state,
				sectionWiseFetchResponse: decodeHexResponse(action.payload, 'fetchSectionWiseKey'),
			};
		case SectionWiseFetchDetailsTypes.SECTION_WISE_FETCH_FAILURE:
			return {
				...state,
				sectionWiseFetchResponse: decodeHexResponse(action.payload, 'fetchSectionWiseKey'),
			};
		case SectionWiseFetchDetailsTypes.SECTION_WISE_FETCH_RESPONSE_CHANGED:
			return { ...state, sectionWiseFetchResponse: null };
		// case SectionWiseFetchDetailsTypes.SECTION_WISE_FETCH_RESPONSE_REST_START:
		// 	return { ...state, sectionWiseFetchResponse: null };
		default:
			return state;
	}
};

export default sectionWiseFetchDetailsReducer;
